import { render, staticRenderFns } from "./AntecedentesFamiliares.vue?vue&type=template&id=40b35dc8"
import script from "./AntecedentesFamiliares.vue?vue&type=script&lang=js"
export * from "./AntecedentesFamiliares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports